import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Card from '../UI/Card/Card';
import InputString from '../UI/Control/InputString';
import SelectList from '../UI/Control/SelectList';
import "../ExportTable/index.css";
import './../CustomDataTableExtensions.css';
import Button from '..//UI/Button/Button';
import TextArea from '../UI/Control/InputTextarea';

const AdminToolkits = (props) => {
    const [rowData, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const colum = new Array();
    const [arrAFName, setArrAFName] = useState([]);
    const [afResults, setAfResults] = useState([]);

    const fetchToolkitFunctions = () => {
        fetch('api/AdminToolkits/FillAdminFunctionList')
            .then(response => response.json())
            .then(data => {
                setArrAFName(data);
            });
    }

    function LoadReportParameters(reportId) {
        document.getElementById('divParameter').style.display = 'none';
        document.getElementById('divParameter').innerHTML = '';
        if (reportId > 0) {
            let select = '';
            document.getElementById('divParameter').style.display = 'block';
            fetch('api/AdminToolkits/GetAFParameters?AFID=' + reportId)
                .then(response => response.text())
                .then(data => {
                    if (data != "-1") {
                        var arrParameter = JSON.parse(data);
                        var newTextBoxDiv = document.createElement('div');
                        newTextBoxDiv.setAttribute("class", 'jumbotron');
                        for (var iCount = 0; iCount < arrParameter.length; iCount++) {

                            newTextBoxDiv.setAttribute("id", 'TextBoxDiv' + iCount);
                            //if (arrParameter[iCount].DataType == 'nvarchar') {
                            newTextBoxDiv.innerHTML += '<label>' + arrParameter[iCount].Name.replace('@', '') + ' : </label>';
                            if (arrParameter[iCount].IsMandatory == 'Y') {
                                newTextBoxDiv.innerHTML += '<label style="color:red;">*</label> ';
                            }
                            newTextBoxDiv.innerHTML += ' <input type="text" class="cssParameter form-control" name="txtParameter' + iCount +
                                '" style="width:12%;display:inline;margin-bottom:10px;" id="txt_' + arrParameter[iCount].Name + '" controlType = "text" dataType="' + arrParameter[iCount].DataType + '" parameter="' + arrParameter[iCount].Name.replace('@', '').trim() + '" value="" > ';
                            //}

                            if ((iCount + 1) % 4 == 0) {
                                newTextBoxDiv.innerHTML += "</br>";
                            }

                        }
                        document.getElementById('divParameter').innerHTML = '<label style="font-weight:bold;">Parameters : </label> </br>' + newTextBoxDiv.innerHTML;
                    }
                    else
                        alert("Error while loading report parameter, contact system admin.")
                });
        }
    }


    const onAFChangeHandler = (e) => {
        setColumns([]);
        setRows([]);
        setAfResults('');
        LoadReportParameters(e.target.value);
    }

    function GetFunctionResults() {
        var parameter = new Array();
        var dataType = '';
        var parameterName = '';
        var parameterValue = '';

        let objAFName = document.getElementById("ddlFunctionName");
        var afid = objAFName.value;

        if (afid == '-1') {
            alert('Please select a function name.');
            objAFName.focus();
            return false;
        }

        let objParamaters = document.getElementsByClassName('cssParameter');

        for (var cnt = 0; cnt < objParamaters.length; cnt++) {

            parameterName = objParamaters[cnt].getAttribute('parameter');
            parameterValue = objParamaters[cnt].value.trim();
            dataType = objParamaters[cnt].getAttribute('dataType');

            if (parameterValue == '') {
                alert('"' + parameterName + '" parameter value should not be empty.');
                objParamaters[cnt].focus();
                return false;
            }

            if (parameterValue == '-1') {
                alert('Please select "' + parameterName + '" parameter value.');
                objParamaters[cnt].focus();
                return false;
            }

            if (dataType == 'int' && !/^[0-9]+$/.test(parameterValue)) {
                alert('Please enter numeric value for "' + parameterName + '" parameter!');
                objParamaters[cnt].focus();
                return false;
            }

            parameter.push({ Name: parameterName, Value: parameterValue });
        }

        let model = {
            AFID: afid,
            InputParameterList: parameter
        };

        let searchColumn = new Array();
        fetch('api/AdminToolkits/GetAFResults', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.text()).then(data => {

            if (data != "-1") {
                setAfResults(data);
            }
            else {
                alert("Error while generating Admin function results, contact system admin.");
                setAfResults(data);
            }
        });
    }


    useEffect(() => {
        fetchToolkitFunctions();
    }, []);

    return <Card>
        <Row style={{ marginBottom: "10px" }}>
            <Col md={4}>
                <div className="input-group">
                    <SelectList id='ddlFunctionName' dataSource={arrAFName} onChangeHandler={onAFChangeHandler} />
                </div>
            </Col>
            <Col md={2}>
                <Button id="btnLoadReport" className="btn btn-success" style={{ marginRight: "10px" }} onClick={GetFunctionResults}> Submit </Button>
            </Col>
            <Col md={6}>
            </Col>

        </Row>
        <div class="row">
            <div class="col-sm-12">
                <div id='divParameter' style={{ backgroundColor: "antiquewhite", padding: "10px", borderStyle: "solid", borderWidth: "1px", borderColor: "silver", display: "none" }}>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <Col md={12}>
                    Results: 
                    <TextArea id="txtResults" rows='20' cols='100' style={{ "resize": "none" }} value={afResults} />
                </Col>
            </div>
        </div>
    </Card>
}

export default AdminToolkits;